import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {ProductProps} from 'modules/products/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CategoryProps {
  id: string;
  name: string;
  active: boolean;
  companyId: string;
  company: CompanyProps;
  companyName: string;
  products: ProductProps[];
  cityId: string;
  cityName: string;
}

export const translatedCategoryProps: TranslatedKeys<CategoryProps> = {
  name: 'Nome',
  active: 'Ativo?',
  companyId: 'Empresa',
  company: {...translatedCompanyProps, name: 'Empresa'},
  companyName: 'Empresa',
  products: 'Produtos',
  cityId: 'Cidade',
  cityName: 'Cidade',
};
